import { Component } from "react";
import { Crown } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("DLA-ERROR:", String(error && error.message ? error.message : error), errorInfo && errorInfo.componentStack);
    const isChunkError = /loading chunk|chunkloaderror|dynamically imported/i.test(
      String(error && error.message ? error.message : error)
    );
    if (isChunkError) {
      try {
        if (!sessionStorage.getItem("dla-chunk-reloaded")) {
          sessionStorage.setItem("dla-chunk-reloaded", "1");
          const url = new URL(window.location.href);
          url.searchParams.set("_r", String(Date.now()));
          window.location.replace(url.toString());
        }
      } catch (e) {
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-fallback" className="flex min-h-screen flex-col items-center justify-center bg-[#050505] px-6 text-center text-white">
          <Crown className="h-10 w-10 text-[#D4AF37]" strokeWidth={1} />
          <h1 className="font-display mt-6 text-4xl font-medium">Something Interrupted the Show</h1>
          <p className="mt-4 max-w-md text-sm font-light leading-relaxed text-neutral-400">
            The page was updated moments ago — a quick refresh brings everything back.
          </p>
          <button
            data-testid="app-error-refresh-button"
            onClick={() => {
              const url = new URL(window.location.href);
              url.searchParams.set("_r", String(Date.now()));
              window.location.replace(url.toString());
            }}
            className="mt-8 bg-[#D4AF37] px-10 py-4 text-xs font-medium uppercase tracking-[0.3em] text-black transition-colors hover:bg-[#F9F1CC]"
          >
            Refresh the Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
